module.exports = __webpack_public_path__ + "static/img/source3.5ac3d9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equipment/en/source3.jpg
// module id = 3tHr
// module chunks = 1